import React from 'react';

const Click = React.forwardRef<SVGSVGElement, Props>((props, ref) => {
  const { width, height, color, strokeWidth, ...others } = props;

  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      {...others}
    >
      <path
        d="M18.4116 11.5531H18.2945C18.0364 11.5531 17.7912 11.6098 17.5709 11.7114C17.4018 10.9302 16.7057 10.3434 15.8749 10.3434H15.7575C15.4613 10.3434 15.1825 10.4179 14.9383 10.5492C14.6757 9.92456 14.0573 9.48475 13.3382 9.48475H13.2208C12.9779 9.48475 12.7463 9.5349 12.5365 9.62549V7.14206C12.5365 6.18524 11.7582 5.40723 10.8014 5.40723H10.684C9.72748 5.40723 8.94921 6.1855 8.94921 7.14206V13.5124L8.16017 14.1113C7.53157 14.5884 7.13324 15.2827 7.03819 16.0659C6.94314 16.8495 7.16397 17.6188 7.66049 18.2324L10.1229 21.2767V22.4867C10.1229 23.2195 10.7192 23.8161 11.4521 23.8161H17.5992C18.3321 23.8161 18.9286 23.2198 18.9286 22.4867L18.9289 21.3379C19.7156 20.3491 20.147 19.1223 20.147 17.8609V13.2879C20.1465 12.3313 19.3684 11.5531 18.4116 11.5531ZM19.0962 17.8606C19.0962 18.9377 18.7081 19.9843 18.0041 20.8078C17.9224 20.9028 17.8781 21.0239 17.8781 21.1491V22.4867C17.8781 22.6405 17.7528 22.7658 17.599 22.7658H11.4521C11.2985 22.7658 11.1732 22.6405 11.1732 22.4867V21.0908C11.1732 20.9706 11.132 20.854 11.0564 20.7605L8.4771 17.5718C8.16096 17.1811 8.02022 16.6911 8.08088 16.1922C8.14127 15.6936 8.39518 15.2514 8.79534 14.9476L8.94921 14.831V16.2739C8.94921 16.5638 9.18448 16.799 9.47436 16.799C9.76424 16.799 9.99951 16.5638 9.99951 16.2739V13.7779C9.99951 13.7742 9.99951 13.771 9.99951 13.7673V7.1418C9.99951 6.76421 10.3065 6.45726 10.684 6.45726H10.8014C11.179 6.45726 11.4859 6.76448 11.4859 7.1418V11.2196C11.4859 11.2196 11.4859 11.2196 11.4859 11.2198C11.4859 11.2201 11.4859 11.2198 11.4859 11.2201L11.4886 14.6118C11.4888 14.9017 11.7238 15.1364 12.0137 15.1364H12.014C12.3039 15.1362 12.5389 14.9011 12.5386 14.6107L12.5362 11.2196C12.5362 10.842 12.8432 10.5351 13.2205 10.5351H13.3379C13.7155 10.5351 14.0224 10.8423 14.0224 11.2196V12.0782V12.0785V12.0787L14.0248 14.6118C14.025 14.9017 14.2601 15.1364 14.5499 15.1364C14.5502 15.1364 14.5502 15.1364 14.5505 15.1364C14.8403 15.1362 15.0753 14.9009 15.0751 14.6107L15.0727 12.0779C15.0727 11.7004 15.3797 11.3934 15.757 11.3934H15.8744C16.2519 11.3934 16.5589 11.7006 16.5589 12.0779V13.1513C16.5573 13.1687 16.5536 13.1855 16.5536 13.2031L16.5563 14.6121C16.5568 14.9019 16.7918 15.1362 17.0814 15.1362C17.0817 15.1362 17.0819 15.1362 17.0825 15.1362C17.3723 15.1356 17.6071 14.9001 17.6066 14.61L17.6042 13.3359C17.6058 13.3197 17.6092 13.3042 17.6092 13.2876C17.6092 12.91 17.9164 12.6031 18.2937 12.6031H18.4108C18.7884 12.6031 19.0954 12.9103 19.0954 13.2876V17.8606H19.0962Z"
        fill={color}
      />
      <path
        d="M16.9874 6.88258H13.783C13.4931 6.88258 13.2578 6.64731 13.2578 6.35743C13.2578 6.06754 13.4931 5.83228 13.783 5.83228H16.9874C17.2773 5.83228 17.5126 6.06754 17.5126 6.35743C17.5126 6.64731 17.2776 6.88258 16.9874 6.88258Z"
        fill={color}
      />
      <path
        d="M10.6834 4.43885C10.3935 4.43885 10.1582 4.20358 10.1582 3.9137V0.709232C10.1582 0.419349 10.3935 0.184082 10.6834 0.184082C10.9732 0.184082 11.2085 0.419349 11.2085 0.709232V3.9137C11.2085 4.20384 10.9735 4.43885 10.6834 4.43885Z"
        fill={color}
      />
      <path
        d="M12.9343 5.0262C12.7998 5.0262 12.6656 4.97499 12.563 4.87233C12.3579 4.66726 12.3579 4.33484 12.563 4.12977L14.829 1.86401C15.0341 1.65894 15.3665 1.65894 15.5716 1.86401C15.7766 2.06908 15.7766 2.4015 15.5716 2.60657L13.3055 4.87233C13.2029 4.97499 13.0684 5.0262 12.9343 5.0262Z"
        fill={color}
      />
      <path
        d="M7.58411 6.88258H4.37964C4.08976 6.88258 3.85449 6.64731 3.85449 6.35743C3.85449 6.06754 4.08976 5.83228 4.37964 5.83228H7.58411C7.87399 5.83228 8.10926 6.06754 8.10926 6.35743C8.10926 6.64731 7.87399 6.88258 7.58411 6.88258Z"
        fill={color}
      />
      <path
        d="M8.43244 5.0262C8.298 5.0262 8.16357 4.97499 8.06116 4.87233L5.7954 2.60657C5.59033 2.4015 5.59033 2.06908 5.7954 1.86401C6.00021 1.65894 6.33316 1.65894 6.53797 1.86401L8.80372 4.12977C9.00879 4.33484 9.00879 4.66726 8.80372 4.87233C8.70132 4.97499 8.56688 5.0262 8.43244 5.0262Z"
        fill={color}
      />
    </svg>
  );
});

Click.defaultProps = {
  color: '#ffffff',
  width: 15,
  height: 15,
};

export default Click;

type Props = {
  color?: string;
  width?: number | string;
  height?: number | string;
  className?: string; // Required to apply styling via Styled-Components
} & React.SVGProps<SVGSVGElement>;
